import React from "react";
import { Link } from "react-router-dom";
// import { RoughNotation } from "react-rough-notation";
import { Fade } from "react-awesome-reveal";

// const rootStyles = getComputedStyle(document.documentElement);
// const primaryColor = rootStyles.getPropertyValue("--primary").trim();

export default function Taglinedomain() {
  return (
    <div className="home-page">
      <div className="container-fluid main">
        <div className="row">
          <div className="col-sm-8 ">
            <h1 className="head">
              <span className="headcolor">Hi there.</span> I’m{" "}
              {/* <RoughNotation
                type="box"
                show="true"
                color={primaryColor}
                strokeWidth={2}
                padding={2}
              >
                Anshul,
              </RoughNotation>{" "} */}
              Anshul, a ServiceNow Developer and Design Engineer.
            </h1>
            <br />
            <h5>
              Building scalable enterprise workflows and crafting
              high-performance web applications with React.
            </h5>
            <br />

            <Fade direction="down" duration={2000}>
              {/* <Link to="/about" className="btn-available">
                <i className="ri-sparkling-line iconf"></i>{" "}
                <span className="fw-bold text-capitalize">Connect</span>
              </Link> */}
              <Link to="/about">
                <div className={`status-badge current`}>
                  <span className="status-dot"></span>
                  Currently working at TCS
                </div>
              </Link>
            </Fade>
            <br />
            <h5 className="hoverclass">
              Automating the complex. Designing the simple{" "}
              <i className="ri-rocket-line"></i>
            </h5>
          </div>
          <div className="col-sm-4"></div>
        </div>
      </div>
    </div>
  );
}
